export const IconBillFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconBillFilled_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconBillFilled_svg__a)">
        <path d="M11 18v.5q0 .2.15.35t.35.15h1a.48.48 0 0 0 .35-.15q.15-.15.15-.35V18h1q.424 0 .713-.288A.97.97 0 0 0 15 17v-3a.97.97 0 0 0-.287-.713A.97.97 0 0 0 14 13h-3v-1h3q.424 0 .713-.287A.97.97 0 0 0 15 11a.97.97 0 0 0-.287-.713A.97.97 0 0 0 14 10h-1v-.5a.48.48 0 0 0-.15-.35.48.48 0 0 0-.35-.15h-1a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35v.5h-1a.97.97 0 0 0-.713.287A.97.97 0 0 0 9 11v3q0 .424.287.713Q9.576 15 10 15h3v1h-3a.97.97 0 0 0-.713.288A.97.97 0 0 0 9 17q0 .424.287.712Q9.576 18 10 18zm-5 4q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 20V4q0-.824.588-1.412A1.93 1.93 0 0 1 6 2h9l5 5v13q0 .824-.587 1.413A1.93 1.93 0 0 1 18 22zm8-18v3q0 .424.287.713Q14.576 8 15 8h3z" />
      </g>
    </svg>
  );
};
